module.exports = __webpack_public_path__ + "static/media/cmd.71925259.png";